'use es6';

import I18n from 'I18n';
const VerificationEmailResendError = () => `
  <p class="display-inline">
    <strong>${I18n.text('emailConfirmBar.resendErrorText')}</strong>
  </p>
`;
export default VerificationEmailResendError;